/* assets/pl-product-media.js
   Extracted from snippets/product-media.liquid. This shipped as ~40KB of
   uncached, unminified inline <script> on every PDP render; as an asset it is
   fetched once and cached. Liquid-dependent values are read from the
   window.PLProductMedia config object emitted by the snippet. */
var PLPM = (window.PLProductMedia = window.PLProductMedia || {});
if (typeof PLPM.hasDesktopGallery === 'undefined') PLPM.hasDesktopGallery = false;
if (typeof PLPM.zoomEnabled === 'undefined') PLPM.zoomEnabled = false;
PLPM.pauseLabel = PLPM.pauseLabel || 'Pause video';
PLPM.playLabel = PLPM.playLabel || 'Play video';

/* Input modality flag.
   initKeyboardNavigation below makes .product__media and .hc-pdp-media-grid
   focusable (tabindex="0") so arrow keys can drive the carousel. A tap on the
   hero image focuses that container, and Safari matches :focus-visible on a
   focusable div after touch, so the keyboard focus ring paints over the image.
   Recording how focus was most recently initiated lets the CSS keep the ring
   for keyboard users and drop it for pointer users. Listeners are capture
   phase on document so they run before any focus handler. */
(function () {
  var root = document.documentElement;
  function setSource(value) {
    if (root.getAttribute('data-pl-focus') !== value) {
      root.setAttribute('data-pl-focus', value);
    }
  }
  document.addEventListener('pointerdown', function () { setSource('pointer'); }, true);
  document.addEventListener('touchstart', function () { setSource('pointer'); }, { capture: true, passive: true });
  document.addEventListener('mousedown', function () { setSource('pointer'); }, true);
  document.addEventListener('keydown', function (event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    setSource('key');
  }, true);
})();

    // =====================================================
    // MAIN SCRIPT
    // =====================================================
    (function() {
      const DESKTOP_BREAKPOINT = 1000;
      const hasDesktopGallery = PLPM.hasDesktopGallery;
      let currentMode = null;
      let videoOriginalParents = new Map();

      function playVideo(nativeVideo) {
        if (!nativeVideo) return;
        let video = nativeVideo.querySelector('video');
        if (!video && typeof nativeVideo.play === 'function') {
          nativeVideo.play();
          video = nativeVideo.querySelector('video');
        }
        if (video && video.paused) {
          video.muted = true;
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              if (error.name !== 'AbortError') console.warn('Video play error:', error);
            });
          }
        }
      }

      function moveVideosToGrid() {
        if (!hasDesktopGallery) return;
        document.querySelectorAll('[data-video-id]').forEach(videoContainer => {
          const mediaId = videoContainer.dataset.videoId;
          const slot = document.querySelector(`[data-video-slot-for="${mediaId}"]`);
          if (slot && videoContainer.parentElement) {
            if (!videoOriginalParents.has(mediaId)) {
              videoOriginalParents.set(mediaId, videoContainer.parentElement);
            }
            slot.appendChild(videoContainer);
            // data-autoplay (not autoplay): Focal's NativeVideo instantiates and
            // downloads any native-video[autoplay] on upgrade, including hidden
            // other-color videos. Only play slots that are actually visible;
            // the IntersectionObserver in initVideoLazyLoading covers the rest.
            const nativeVideo = videoContainer.querySelector('native-video[data-autoplay]');
            if (nativeVideo && !slot.closest('.is-filtered')) setTimeout(() => playVideo(nativeVideo), 200);
          }
        });
      }

      function moveVideosToCarousel() {
        document.querySelectorAll('[data-video-slot-for]').forEach(slot => {
          const mediaId = slot.dataset.videoSlotFor;
          const videoContainer = slot.querySelector('[data-video-id]');
          const originalParent = videoOriginalParents.get(mediaId);
          if (videoContainer && originalParent) originalParent.appendChild(videoContainer);
        });
      }

      let videoObserver = null;
      function initVideoLazyLoading() {
        const videoItems = document.querySelectorAll('.product__media-item[data-media-type="video"], .product__media-item[data-media-type="external_video"]');
        if (!videoItems.length) return;
        const autoplayEnabled = document.querySelector('product-media[autoplay-video]') !== null;
        // One observer for the page; items are observed once (lazy media groups
        // re-run this after inserting a new color's items).
        const observer = videoObserver || (videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const nativeVideo = entry.target.querySelector('native-video');
            const externalVideo = entry.target.querySelector('external-video');
            if (entry.isIntersecting) {
              if (nativeVideo && autoplayEnabled) playVideo(nativeVideo);
              if (externalVideo && autoplayEnabled && typeof externalVideo.play === 'function') externalVideo.play();
              entry.target.classList.add('is-in-viewport');
            } else {
              if (nativeVideo) {
                const video = nativeVideo.querySelector('video');
                if (video && !video.paused) video.pause();
              }
              if (externalVideo) {
                const iframe = externalVideo.querySelector('iframe');
                if (iframe) {
                  const src = iframe.src || '';
                  if (src.includes('youtube')) {
                    iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
                  } else if (src.includes('vimeo')) {
                    iframe.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
                  }
                }
              }
              entry.target.classList.remove('is-in-viewport');
            }
          });
        }, { threshold: 0.3, rootMargin: '100px 0px' }));
        const observeOnce = item => {
          if (item.dataset.plVideoObserved) return;
          item.dataset.plVideoObserved = 'true';
          observer.observe(item);
        };
        videoItems.forEach(observeOnce);
        document.querySelectorAll('.hc-pdp-media-grid .product__media-item[data-media-type="video"], .hc-pdp-media-grid .product__media-item[data-media-type="external_video"]').forEach(observeOnce);
      }

      function handleViewport() {
        const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
        const newMode = isDesktop ? 'desktop' : 'mobile';
        if (newMode === currentMode) return;
        currentMode = newMode;
        if (isDesktop && hasDesktopGallery) {
          moveVideosToGrid();
        } else {
          moveVideosToCarousel();
        }
        initVideoLazyLoading();
      }

      // =====================================================
      // FIX: Force full-width edge-to-edge slides on mobile.
      // Flickity initializes with centerMode:true + centerPadding:20
      // which the theme carousel JS requires for swiping to work.
      // We mutate the live instance after init to get edge-to-edge,
      // and keep the wrapper opacity:0 until corrected to hide the flash.
      // =====================================================
      async function initMobileFullWidthCarousel() {
  if (window.innerWidth >= DESKTOP_BREAKPOINT) return;

  const wrapper = document.querySelector('.product__media-list-wrapper');

  // Single image: Flickity won't fully init with draggable:">1", reveal immediately
  const visibleSlides = document.querySelectorAll(
    '.product__media-list .product__media-item:not(.is-filtered)'
  );
  if (visibleSlides.length <= 1) {
    if (wrapper) wrapper.classList.add('hc-carousel-ready');
    return;
  }

  const flickityCarousel = document.querySelector('flickity-carousel');
  if (!flickityCarousel) {
    if (wrapper) wrapper.classList.add('hc-carousel-ready');
    return;
  }

  // Safety net: always reveal after 1.5s regardless of Flickity state
  const revealFallback = setTimeout(() => {
    if (wrapper) wrapper.classList.add('hc-carousel-ready');
  }, 1500);

  try {
    const flkty = await (flickityCarousel.flickity || Promise.resolve(null));
    clearTimeout(revealFallback);

    if (!flkty) {
      if (wrapper) wrapper.classList.add('hc-carousel-ready');
      return;
    }

    // NOTE: do not write wrapper.style.width here. The mobile full-bleed is
    // done in CSS with width:auto + negative margins so the wrapper's rendered
    // width matches the width the aspect-ratio height reservation is computed
    // from. An inline width:100% would clamp it back to the gutter-inset
    // container width and shorten the reserved box.
    if (wrapper) {
      wrapper.style.maxWidth = 'none';
    }

    flkty.options.centerMode = false;
    flkty.options.contain = true;
    flkty.options.cellAlign = 'left';
    flkty.options.centerPadding = '0px';

    flkty.cells.forEach(cell => {
      cell.element.style.width = '100%';
    });

    flkty.resize();

    if (wrapper) wrapper.classList.add('hc-carousel-ready');

  } catch (e) {
    clearTimeout(revealFallback);
    if (wrapper) wrapper.classList.add('hc-carousel-ready');
    console.warn('Mobile full-width carousel error:', e);
  }
}

// Hard fallback: if hc-carousel-ready still missing after 1.5s, force it
setTimeout(() => {
  const wrapper = document.querySelector('.product__media-list-wrapper');
  if (wrapper && !wrapper.classList.contains('hc-carousel-ready')) {
    wrapper.classList.add('hc-carousel-ready');
  }
}, 1500);

      // =====================================================
      // MOBILE LIGHTBOX ZOOM
      // Tapping an image on mobile opens a fullscreen overlay.
      // Desktop zoom is handled separately by initImageZoom().
      // =====================================================
      function initMobileLightbox() {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) return;

        // Navigable image slides, rebuilt each time the lightbox opens so it
        // respects the current variant-filtered state. Videos are excluded
        // (they have no image wrapper, so they are skipped naturally).
        let slides = [];
        let currentIndex = 0;

        // Build lightbox if it doesn't exist yet
        let lightbox = document.getElementById('hc-mobile-lightbox');
        if (!lightbox) {
          lightbox = document.createElement('div');
          lightbox.id = 'hc-mobile-lightbox';
          lightbox.setAttribute('role', 'dialog');
          lightbox.setAttribute('aria-modal', 'true');
          lightbox.setAttribute('aria-label', 'Zoomed product image');
          lightbox.innerHTML = `
            <div class="hc-lightbox__overlay" aria-hidden="true"></div>
            <div class="hc-lightbox__content">
              <button type="button" class="hc-lightbox__close" aria-label="Close zoomed image">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
              <button type="button" class="hc-lightbox__nav hc-lightbox__nav--prev" aria-label="Previous image">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
              </button>
              <img class="hc-lightbox__image" src="" alt="">
              <button type="button" class="hc-lightbox__nav hc-lightbox__nav--next" aria-label="Next image">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </button>
              <p class="hc-lightbox__counter" aria-hidden="true"></p>
              <span class="hc-lightbox__live sr-only" aria-live="polite" aria-atomic="true"></span>
            </div>
          `;
          document.body.appendChild(lightbox);
        }

        const overlay = lightbox.querySelector('.hc-lightbox__overlay');
        const closeBtn = lightbox.querySelector('.hc-lightbox__close');
        const prevBtn = lightbox.querySelector('.hc-lightbox__nav--prev');
        const nextBtn = lightbox.querySelector('.hc-lightbox__nav--next');
        const lightboxImg = lightbox.querySelector('.hc-lightbox__image');
        const counterEl = lightbox.querySelector('.hc-lightbox__counter');
        const liveEl = lightbox.querySelector('.hc-lightbox__live');

        function collectSlides() {
          slides = [];
          document.querySelectorAll('.product__media-list .product__media-item:not(.is-filtered)').forEach(item => {
            const wrapper = item.querySelector('.product__media-image-wrapper');
            if (!wrapper) return; // video items have no image wrapper - skipped
            const img = wrapper.querySelector('img');
            if (!img) return;
            slides.push({
              slideEl: item,
              src: wrapper.dataset.zoomSrc || img.currentSrc || img.src,
              alt: img.alt || ''
            });
          });
        }

        function showSlide(index) {
          if (!slides.length) return;
          const total = slides.length;
          currentIndex = (index + total) % total; // wrap around
          const slide = slides[currentIndex];
          lightboxImg.src = slide.src;
          lightboxImg.alt = slide.alt;
          counterEl.textContent = (currentIndex + 1) + ' / ' + total;
          liveEl.textContent = 'Image ' + (currentIndex + 1) + ' of ' + total;
          const single = total <= 1;
          prevBtn.hidden = single;
          nextBtn.hidden = single;
          counterEl.hidden = single;
        }

        function openLightbox(startIndex) {
          showSlide(startIndex);
          lightbox.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          // Focus close button for keyboard users
          closeBtn.focus();
        }

        function closeLightbox() {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
          // Sync the on-page carousel to wherever the user ended up
          const target = slides[currentIndex] && slides[currentIndex].slideEl;
          if (target) {
            const fc = document.querySelector('flickity-carousel');
            if (fc && fc.flickity) {
              Promise.resolve(fc.flickity).then(function(flkty) {
                if (flkty && typeof flkty.selectCell === 'function') {
                  try { flkty.selectCell(target, false, true); } catch (err) {}
                }
              }).catch(function() {});
            }
          }
          // Return focus to the zoom button that opened the lightbox
          const trigger = document.querySelector('.hc-lightbox-trigger--active');
          if (trigger) {
            trigger.focus();
            trigger.classList.remove('hc-lightbox-trigger--active');
          }
        }

        // Bind dialog controls once
        if (!lightbox.dataset.controlsBound) {
          lightbox.dataset.controlsBound = 'true';

          overlay.addEventListener('click', closeLightbox);
          closeBtn.addEventListener('click', closeLightbox);
          prevBtn.addEventListener('click', function() { showSlide(currentIndex - 1); });
          nextBtn.addEventListener('click', function() { showSlide(currentIndex + 1); });

          // Keyboard: arrows navigate, Escape closes, Tab stays trapped in the dialog
          lightbox.addEventListener('keydown', function(e) {
            if (!lightbox.classList.contains('is-open')) return;
            if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); return; }
            if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(currentIndex - 1); return; }
            if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(currentIndex + 1); return; }
            if (e.key === 'Tab') {
              const focusables = Array.prototype.slice
                .call(lightbox.querySelectorAll('button:not([hidden])'))
                .filter(function(el) { return el.offsetParent !== null; });
              if (!focusables.length) return;
              const first = focusables[0];
              const last = focusables[focusables.length - 1];
              if (e.shiftKey && document.activeElement === first) {
                e.preventDefault(); last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault(); first.focus();
              }
            }
          });

          // Touch swipe navigation - horizontal only, ignore vertical/pinch
          let touchStartX = 0, touchStartY = 0, touchActive = false;
          lightboxImg.addEventListener('touchstart', function(e) {
            if (e.touches.length !== 1) { touchActive = false; return; }
            touchActive = true;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
          }, { passive: true });
          lightboxImg.addEventListener('touchend', function(e) {
            if (!touchActive) return;
            touchActive = false;
            const touch = e.changedTouches[0];
            const dx = touch.clientX - touchStartX;
            const dy = touch.clientY - touchStartY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              dx < 0 ? showSlide(currentIndex + 1) : showSlide(currentIndex - 1);
            }
          }, { passive: true });
        }

        // Attach open handler to each zoom button (idempotent).
        // Only the explicit zoom button opens the lightbox - swipe on the
        // carousel itself is unaffected.
        document.querySelectorAll('.product__media-list .hc-mobile-zoom-btn').forEach(btn => {
          if (btn.dataset.lightboxInitialized) return;
          btn.dataset.lightboxInitialized = 'true';

          btn.addEventListener('click', function(e) {
            e.stopPropagation(); // Don't trigger Flickity click-nav
            const wrapper = btn.closest('.product__media-image-wrapper');
            const img = wrapper ? wrapper.querySelector('img') : null;
            if (!img) return;
            collectSlides();
            const item = btn.closest('.product__media-item');
            let startIndex = slides.findIndex(function(s) { return s.slideEl === item; });
            if (startIndex < 0) startIndex = 0;
            // Mark this button as the focus-return target
            btn.classList.add('hc-lightbox-trigger--active');
            openLightbox(startIndex);
          });
        });
      }

      function initVideoPauseButtons() {
        document.querySelectorAll('.video-pause-button').forEach(button => {
          if (button.dataset.initialized) return;
          button.dataset.initialized = 'true';
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const container = this.closest('.product__media-video-container');
            if (!container) return;
            const video = container.querySelector('video');
            const iframe = container.querySelector('iframe');
            const isPaused = this.dataset.paused === 'true';
            if (video) {
              if (isPaused) {
                const playPromise = video.play();
                if (playPromise !== undefined) {
                  playPromise.catch((error) => {
                    if (error.name !== 'AbortError') console.warn('Video play error:', error);
                  });
                }
                this.dataset.paused = 'false';
                this.setAttribute('aria-label', PLPM.pauseLabel);
              } else {
                video.pause();
                this.dataset.paused = 'true';
                this.setAttribute('aria-label', PLPM.playLabel);
              }
            } else if (iframe) {
              const src = iframe.src;
              if (src.includes('youtube')) {
                iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: isPaused ? 'playVideo' : 'pauseVideo' }), '*');
              } else if (src.includes('vimeo')) {
                iframe.contentWindow.postMessage(JSON.stringify({ method: isPaused ? 'play' : 'pause' }), '*');
              }
              this.dataset.paused = isPaused ? 'false' : 'true';
              this.setAttribute('aria-label', isPaused ? PLPM.pauseLabel : PLPM.playLabel);
            }
          });
        });
        document.querySelectorAll('.product__media-video-container').forEach(container => {
          if (container.dataset.plPauseObserved) return;
          container.dataset.plPauseObserved = 'true';
          const observer = new MutationObserver(() => {
            const video = container.querySelector('video');
            const button = container.querySelector('.video-pause-button');
            if (video && button && !video.dataset.pauseListenerAdded) {
              video.dataset.pauseListenerAdded = 'true';
              video.addEventListener('play', () => {
                button.dataset.paused = 'false';
                button.setAttribute('aria-label', PLPM.pauseLabel);
              });
              video.addEventListener('pause', () => {
                button.dataset.paused = 'true';
                button.setAttribute('aria-label', PLPM.playLabel);
              });
            }
          });
          observer.observe(container, { childList: true, subtree: true });
        });
      }

      // =====================================================
      // FIX: Ensure videos always loop on desktop and mobile.
      // Forces loop attribute on all product videos and adds
      // an ended-event safety net to restart playback.
      // =====================================================
      function initVideoLooping() {
        function ensureLoop(video) {
          if (!video || video.dataset.loopInitialized) return;
          video.dataset.loopInitialized = 'true';
          video.loop = true;
          video.setAttribute('loop', '');
          video.addEventListener('ended', function() {
            this.currentTime = 0;
            var playPromise = this.play();
            if (playPromise !== undefined) {
              playPromise.catch(function(error) {
                if (error.name !== 'AbortError') console.warn('Video loop restart error:', error);
              });
            }
          });
        }
        // Handle videos already in the DOM
        document.querySelectorAll('.product__media-video-container video').forEach(ensureLoop);
        // Watch for videos loaded from templates (native-video replaces content)
        document.querySelectorAll('.product__media-video-container').forEach(function(container) {
          if (container.dataset.plLoopObserved) return;
          container.dataset.plLoopObserved = 'true';
          var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.tagName === 'VIDEO') { ensureLoop(node); }
                  var vid = node.querySelector && node.querySelector('video');
                  if (vid) ensureLoop(vid);
                }
              });
            });
          });
          observer.observe(container, { childList: true, subtree: true });
        });
        // Handle external videos (YouTube/Vimeo) loop restart
        document.querySelectorAll('.product__media-video-container').forEach(function(container) {
          if (container.dataset.plExtLoopObserved) return;
          container.dataset.plExtLoopObserved = 'true';
          var extObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                var iframe = node.tagName === 'IFRAME' ? node : (node.querySelector && node.querySelector('iframe'));
                if (!iframe || iframe.dataset.loopInitialized) return;
                iframe.dataset.loopInitialized = 'true';
                window.addEventListener('message', function(event) {
                  try {
                    var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                    if (data.event === 'onStateChange' && data.info === 0) {
                      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }), '*');
                      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
                    }
                    if (data.event === 'ended' || (data.method === 'getEnded' && data.value === true)) {
                      iframe.contentWindow.postMessage(JSON.stringify({ method: 'setCurrentTime', value: 0 }), '*');
                      iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
                    }
                  } catch (e) {}
                });
              });
            });
          });
          extObserver.observe(container, { childList: true, subtree: true });
        });
      }

      function initThumbnailFade() {
        const rails = document.querySelectorAll('.product__media-nav .product__thumbnail-list');
        rails.forEach(rail => {
          function update() {
            // 2px of slack absorbs sub-pixel scroll positions, which otherwise
            // leave a fade painted on a rail that is already at its end.
            const maxScroll = rail.scrollWidth - rail.clientWidth;
            const canScroll = maxScroll > 2;
            rail.classList.toggle('hc-thumbs-fade-left', canScroll && rail.scrollLeft > 2);
            rail.classList.toggle('hc-thumbs-fade-right', canScroll && rail.scrollLeft < maxScroll - 2);
          }

          if (!rail.dataset.fadeBound) {
            rail.dataset.fadeBound = 'true';
            rail.addEventListener('scroll', update, { passive: true });
            // Thumbnails are lazy loaded, so scrollWidth is not final at init.
            // ResizeObserver on the inner track catches the width settling
            // without polling.
            const track = rail.querySelector('.product__thumbnail-list-inner');
            if (track && 'ResizeObserver' in window) {
              new ResizeObserver(update).observe(track);
            }
          }

          update();
        });
      }

      function init() {
        setTimeout(() => {
          handleViewport();
          initVideoPauseButtons();
          initVideoLooping();
          initKeyboardNavigation();
          initImageZoom();
          initMobileLightbox();
          initAriaHiddenObserver();
          fixVideoPosterAltText();
          initLazyImageResizeHandler();
          initMobileFullWidthCarousel(); // Must run after Flickity initializes
          initThumbnailFade();
          ensureRovingTabindex('.product__thumbnail-list', '.product__thumbnail-item');
          ensureRovingTabindex('.dots-nav', '.dots-nav__item');

          let resizeTimeout;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              handleViewport();
              initMobileFullWidthCarousel();
              initMobileLightbox();
              initThumbnailFade();
              eagerLoadVisibleCarouselImages();
            }, 150);
          });
        }, 100);
      }

      // =====================================================
      // FIX: adaptiveHeight + lazy images causes collapse
      // Pre-load images on thumbnail hover, lock viewport
      // height during transitions to prevent layout shift.
      // =====================================================
      async function eagerLoadVisibleCarouselImages(knownFlkty) {
        const flickityCarousel = document.querySelector('flickity-carousel');
        if (!flickityCarousel || flickityCarousel.offsetParent === null) return;
        let flkty = knownFlkty;
        if (!flkty && flickityCarousel.flickity) {
          try { flkty = await flickityCarousel.flickity; } catch (e) { flkty = null; }
        }
        document.querySelectorAll('.product__media-list .product__media-item:not(.is-filtered) .product__media-image-wrapper img').forEach(img => {
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          if (!img.complete && !img.dataset.plResizeBound) {
            img.dataset.plResizeBound = 'true';
            img.addEventListener('load', function() {
              if (flkty && typeof flkty.resize === 'function') flkty.resize();
            }, { once: true });
          }
        });
      }

      const plBoundFlickities = new WeakSet();
      function initLazyImageResizeHandler() {
        const flickityCarousel = document.querySelector('flickity-carousel');
        if (!flickityCarousel || !flickityCarousel.flickity) return;
        const initFlickity = async () => {
          try {
            const flkty = await flickityCarousel.flickity;
            if (!flkty) return;
            // Focal's reload() (color change) creates a new Flickity instance;
            // bind handlers once per instance.
            if (plBoundFlickities.has(flkty)) { eagerLoadVisibleCarouselImages(flkty); return; }
            plBoundFlickities.add(flkty);

            // --- Pre-load the VISIBLE carousel images eagerly ---
            // Only cells for the selected color (not .is-filtered) are Flickity
            // cells, so only they need eager load + resize-on-load to avoid the
            // adaptiveHeight collapse. Filtered cells (other colors) stay lazy -
            // previously every color's images were forced eager, downloading
            // 50+ hidden images per PDP. Skipped entirely when the carousel is
            // not rendered (desktop grid mode); re-run on variant change and on
            // viewport switch so newly visible cells get the same treatment.
            eagerLoadVisibleCarouselImages(flkty);
            if (!window.__plEagerVariantBound) {
              window.__plEagerVariantBound = true;
              document.addEventListener('variant:changed', function() {
                // Focal toggles .is-filtered and reloads Flickity in the same
                // handler; wait a frame so we read the new filter state.
                requestAnimationFrame(function() {
                  eagerLoadVisibleCarouselImages();
                });
              });
            }

            // --- Pre-load on thumbnail hover ---
            const thumbnailButtons = document.querySelectorAll('.product__thumbnail-item[data-action="select"]');
            thumbnailButtons.forEach(btn => {
              btn.addEventListener('mouseenter', function() {
                const targetId = this.getAttribute('aria-controls');
                if (!targetId) return;
                const targetSlide = document.getElementById(targetId);
                if (!targetSlide) return;
                const img = targetSlide.querySelector('.product__media-image-wrapper img');
                if (img && !img.complete) {
                  img.loading = 'eager';
                  if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
                }
              }, { once: true });
            });

            // --- Lock viewport height during slide transitions ---
            const viewport = flickityCarousel.querySelector('.flickity-viewport');
            flkty.on('change', function(index) {
              if (viewport) {
                viewport.style.minHeight = viewport.offsetHeight + 'px';
              }
              const cell = flkty.cells[index];
              if (!cell || !cell.element) {
                setTimeout(() => {
                  flkty.resize();
                  if (viewport) viewport.style.minHeight = '';
                }, 100);
                return;
              }
              const img = cell.element.querySelector('.product__media-image-wrapper img');
              if (!img) {
                setTimeout(() => {
                  flkty.resize();
                  if (viewport) viewport.style.minHeight = '';
                }, 100);
                return;
              }
              if (img.complete && img.naturalHeight > 0) {
                requestAnimationFrame(() => {
                  flkty.resize();
                  if (viewport) viewport.style.minHeight = '';
                });
              } else {
                img.loading = 'eager';
                img.addEventListener('load', function() {
                  flkty.resize();
                  if (viewport) viewport.style.minHeight = '';
                }, { once: true });
                setTimeout(() => {
                  if (viewport) viewport.style.minHeight = '';
                  flkty.resize();
                }, 2000);
              }
            });
            setTimeout(() => flkty.resize(), 200);
          } catch (error) {
            console.warn('Flickity initialization error:', error);
          }
        };
        initFlickity();
      }

      function initKeyboardNavigation() {
        const galleryContainers = document.querySelectorAll('.product__media, .hc-pdp-media-grid');
        let hintShown = false;
        galleryContainers.forEach(container => {
          if (!container.hasAttribute('tabindex')) container.setAttribute('tabindex', '0');
          container.addEventListener('focus', function() {
            // The hint is keyboard guidance, so it should not fire on a tap.
            if (document.documentElement.getAttribute('data-pl-focus') === 'pointer') return;
            if (!hintShown && !sessionStorage.getItem('galleryHintShown')) {
              this.setAttribute('data-show-hint', '');
              hintShown = true;
              sessionStorage.setItem('galleryHintShown', 'true');
              setTimeout(() => this.removeAttribute('data-show-hint'), 3000);
            }
          });
          container.addEventListener('keydown', async function(e) {
            // PL Oct 2026: one move per key press. Flickity moves the slide itself while the carousel has focus
            // (accessibility: true on mouse devices), and accessibility.js handles the other cases and calls
            // preventDefault, so this only acts when neither did. Before, one press moved two or three slides.
            if (e.defaultPrevented) return;
            const flickityCarousel = document.querySelector('flickity-carousel');
            if (!flickityCarousel || !flickityCarousel.flickity) return;
            try {
              const flickity = await flickityCarousel.flickity;
              if (!flickity) return;
              if (flickity.options && flickity.options.accessibility && document.activeElement === flickity.element &&
                  (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
                announceMediaChange(flickity.selectedIndex + 1);
                return;
              }
              switch(e.key) {
                case 'ArrowLeft': e.preventDefault(); flickity.previous(); announceMediaChange(flickity.selectedIndex + 1); break;
                case 'ArrowRight': e.preventDefault(); flickity.next(); announceMediaChange(flickity.selectedIndex + 1); break;
                case 'Home': e.preventDefault(); flickity.select(0); announceMediaChange(1); break;
                case 'End': e.preventDefault(); flickity.select(flickity.slides.length - 1); announceMediaChange(flickity.slides.length); break;
              }
            } catch (error) {
              console.warn('Keyboard navigation error:', error);
            }
          });
        });
        document.addEventListener('keydown', async function(e) {
          // PL Oct 2026: page-level shortcut only while nothing has focus. It used to fire on top of the gallery's own
          // handlers (extra slides per press) and hijacked Left/Right on any focused button or link while the gallery was on screen.
          if (e.defaultPrevented || e.metaKey || e.altKey || e.ctrlKey) return;
          if (document.activeElement && document.activeElement !== document.body && document.activeElement !== document.documentElement) return;
          const gallery = document.querySelector('.product__media');
          if (!gallery) return;
          const rect = gallery.getBoundingClientRect();
          if (!(rect.top < window.innerHeight && rect.bottom > 0)) return;
          const flickityCarousel = document.querySelector('flickity-carousel');
          if (!flickityCarousel || !flickityCarousel.flickity) return;
          try {
            const flickity = await flickityCarousel.flickity;
            if (!flickity) return;
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              e.preventDefault();
              e.key === 'ArrowLeft' ? flickity.previous() : flickity.next();
              announceMediaChange(flickity.selectedIndex + 1);
            }
          } catch (error) {
            console.warn('Global keyboard navigation error:', error);
          }
        });
      }

      function announceMediaChange(currentIndex) {
        const liveRegion = document.querySelector('[id^="product-media-live-region"]');
        const totalMedia = document.querySelectorAll('.product__media-item:not(.is-filtered)').length;
        if (liveRegion) {
          const currentItem = document.querySelector('.product__media-item.is-selected');
          const mediaType = currentItem ? currentItem.dataset.mediaType : 'image';
          const typeLabel = mediaType === 'video' || mediaType === 'external_video' ? 'Video' : 'Image';
          liveRegion.textContent = `${typeLabel} ${currentIndex} of ${totalMedia}`;
        }
      }

      function updateHiddenSlideFocusability() {
        document.querySelectorAll('.product__media-item').forEach(item => {
          const isHidden = item.getAttribute('aria-hidden') === 'true';
          item.querySelectorAll('[tabindex]:not([tabindex="-1"]), button:not([tabindex="-1"]), a[href]:not([tabindex="-1"]), [role="button"]:not([tabindex="-1"])').forEach(el => {
            if (isHidden) {
              if (!el.hasAttribute('data-original-tabindex')) {
                el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') !== null ? el.getAttribute('tabindex') : '0');
              }
              el.setAttribute('tabindex', '-1');
            } else {
              const orig = el.getAttribute('data-original-tabindex');
              if (orig !== null) el.setAttribute('tabindex', (orig === '0' || orig === '') ? '0' : orig);
            }
          });
        });
      }

      function initAriaHiddenObserver() {
        const carouselContainer = document.querySelector('.product__media-list');
        if (!carouselContainer) return;
        const observer = new MutationObserver((mutations) => {
          let needsUpdate = false;
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && (mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'class')) needsUpdate = true;
          });
          if (needsUpdate) {
            clearTimeout(window._ariaHiddenUpdateTimeout);
            window._ariaHiddenUpdateTimeout = setTimeout(updateHiddenSlideFocusability, 50);
          }
        });
        carouselContainer.querySelectorAll('.product__media-item').forEach(item => {
          if (item.dataset.plAriaObserved) return;
          item.dataset.plAriaObserved = 'true';
          observer.observe(item, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
        });
        updateHiddenSlideFocusability();
        const flickityCarousel = document.querySelector('flickity-carousel');
        if (flickityCarousel && flickityCarousel.flickity) {
          (async () => {
            try {
              const flkty = await flickityCarousel.flickity;
              if (flkty && typeof flkty.on === 'function' && !flkty.__plAriaBound) {
                flkty.__plAriaBound = true;
                flkty.on('change', () => setTimeout(updateHiddenSlideFocusability, 50));
                flkty.on('settle', updateHiddenSlideFocusability);
                setTimeout(updateHiddenSlideFocusability, 100);
              }
            } catch (error) {
              console.warn('Flickity listener setup error:', error);
            }
          })();
        }
      }

      function fixVideoPosterAltText() {
        function getProductTitle() {
          const videoContainer = document.querySelector('[data-product-title]');
          if (videoContainer && videoContainer.dataset.productTitle) return videoContainer.dataset.productTitle;
          const titleEl = document.querySelector('.product__title, [data-product-title], h1.title, h1');
          return titleEl?.textContent?.trim() || 'Product';
        }
        function fixExistingImages() {
          document.querySelectorAll('video > img, video img').forEach(img => {
            if (!img.hasAttribute('alt') || img.getAttribute('alt') === '') {
              img.setAttribute('alt', `${getProductTitle()} video poster`);
            }
          });
        }
        fixExistingImages();
        const observer = new MutationObserver((mutations) => {
          let needsFix = false;
          mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'VIDEO' || node.querySelector?.('video')) needsFix = true;
                if (node.classList?.contains('video-wrapper') || node.querySelector?.('.video-wrapper')) needsFix = true;
              }
            });
          });
          if (needsFix) setTimeout(fixExistingImages, 50);
        });
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(fixExistingImages, 500);
        setTimeout(fixExistingImages, 1000);
      }

      function initImageZoom() {
        const zoomEnabled = PLPM.zoomEnabled;
        if (!zoomEnabled) return;
        document.querySelectorAll('.product__media-image-wrapper[data-zoom-src]').forEach(wrapper => {
          if (wrapper.dataset.zoomInitialized) return;
          wrapper.dataset.zoomInitialized = 'true';
          const img = wrapper.querySelector('img');
          if (!img) return;
          const zoomSrc = wrapper.dataset.zoomSrc;
          let highResLoaded = false;
          let highResImage = null;
          wrapper.classList.add('product__media-image-wrapper--zoomable');
          let isZoomed = false;
          const zoomLevel = 2.5;
          function preloadHighRes() {
            if (highResLoaded || !zoomSrc) return;
            highResImage = new Image();
            highResImage.onload = function() { highResLoaded = true; };
            highResImage.src = zoomSrc;
          }
          wrapper.addEventListener('mouseenter', preloadHighRes, { once: true });
          wrapper.addEventListener('click', function(e) {
            if (window.innerWidth < 1000) return; // Mobile uses lightbox instead
            e.preventDefault();
            isZoomed = !isZoomed;
            if (isZoomed) {
              if (highResLoaded && zoomSrc) { img.dataset.originalSrc = img.src; img.src = zoomSrc; }
              wrapper.classList.add('is-zoomed');
              updateZoomPosition(e);
            } else {
              wrapper.classList.remove('is-zoomed');
              img.style.transform = '';
              img.style.transformOrigin = '';
              if (img.dataset.originalSrc) img.src = img.dataset.originalSrc;
            }
          });
          wrapper.addEventListener('mousemove', function(e) { if (!isZoomed) return; updateZoomPosition(e); });
          wrapper.addEventListener('mouseleave', function() {
            if (isZoomed) {
              isZoomed = false;
              wrapper.classList.remove('is-zoomed');
              img.style.transform = '';
              img.style.transformOrigin = '';
              if (img.dataset.originalSrc) img.src = img.dataset.originalSrc;
            }
          });
          function updateZoomPosition(e) {
            const rect = wrapper.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = `${x}% ${y}%`;
            img.style.transform = `scale(${zoomLevel})`;
          }
          const parentSlide = wrapper.closest('.product__media-item');
          const isVisible = !parentSlide || parentSlide.getAttribute('aria-hidden') !== 'true';
          wrapper.setAttribute('tabindex', isVisible ? '0' : '-1');
          wrapper.setAttribute('data-original-tabindex', '0');
          wrapper.setAttribute('role', 'button');
          wrapper.setAttribute('aria-label', 'Click to zoom image');
          wrapper.addEventListener('keydown', function(e) {
            if (window.innerWidth < 1000) return; // Mobile uses lightbox
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              preloadHighRes();
              isZoomed = !isZoomed;
              if (isZoomed) {
                if (highResLoaded && zoomSrc) { img.dataset.originalSrc = img.src; img.src = zoomSrc; }
                wrapper.classList.add('is-zoomed');
                img.style.transformOrigin = '50% 50%';
                img.style.transform = `scale(${zoomLevel})`;
                wrapper.setAttribute('aria-label', 'Press Enter or Space to exit zoom');
              } else {
                wrapper.classList.remove('is-zoomed');
                img.style.transform = '';
                img.style.transformOrigin = '';
                if (img.dataset.originalSrc) img.src = img.dataset.originalSrc;
                wrapper.setAttribute('aria-label', 'Click to zoom image');
              }
            } else if (e.key === 'Escape' && isZoomed) {
              isZoomed = false;
              wrapper.classList.remove('is-zoomed');
              img.style.transform = '';
              img.style.transformOrigin = '';
              if (img.dataset.originalSrc) img.src = img.dataset.originalSrc;
              wrapper.setAttribute('aria-label', 'Click to zoom image');
            }
          });
        });
        updateHiddenSlideFocusability();
      }

      // =====================================================
      // LAZY MEDIA GROUPS: re-initialize after a color switch.
      // pl-media-groups.js inserts the new color's items and Focal reloads
      // Flickity (new instance). Everything below is idempotent: handlers are
      // bound once per element / per Flickity instance.
      // =====================================================
      function ensureRovingTabindex(listSelector, itemSelector) {
        document.querySelectorAll(listSelector).forEach(list => {
          // Arrow-key roving over the CURRENTLY visible items. accessibility.js
          // binds per button against a snapshot taken at page load, which after
          // a color change points at hidden (.is-filtered) buttons and never
          // includes inserted ones. Capture phase on the list runs first and
          // stops the stale per-button handlers. Enter/Space fall through to the
          // native button click.
          if (!list.dataset.plRovingBound) {
            list.dataset.plRovingBound = 'true';
            list.addEventListener('keydown', function(e) {
              const current = e.target.closest ? e.target.closest(itemSelector) : null;
              if (!current || !list.contains(current)) return;
              const visible = Array.from(list.querySelectorAll(itemSelector + ':not(.is-filtered)'));
              const idx = visible.indexOf(current);
              if (idx < 0) return;
              let next = -1;
              if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % visible.length;
              else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + visible.length) % visible.length;
              else if (e.key === 'Home') next = 0;
              else if (e.key === 'End') next = visible.length - 1;
              else return;
              e.preventDefault();
              e.stopImmediatePropagation();
              visible.forEach((el, i) => el.setAttribute('tabindex', i === next ? '0' : '-1'));
              visible[next].focus();
            }, true);
          }
          const items = Array.from(list.querySelectorAll(itemSelector + ':not(.is-filtered)'));
          // Filtered items must not keep a tab stop.
          list.querySelectorAll(itemSelector + '.is-filtered[tabindex="0"]').forEach(el => el.setAttribute('tabindex', '-1'));
          if (!items.length) return;
          if (items.some(el => el.getAttribute('tabindex') === '0')) return;
          const current = items.find(el => el.getAttribute('aria-current') === 'true') || items[0];
          current.setAttribute('tabindex', '0');
        });
      }

      async function refreshAfterMediaChange() {
        const flickityCarousel = document.querySelector('flickity-carousel');
        if (flickityCarousel && flickityCarousel.flickity && flickityCarousel.offsetParent !== null) {
          // Flickity only initializes once the carousel is visible, so on
          // desktop-grid pages this promise can stay pending: cap the wait.
          try {
            await Promise.race([flickityCarousel.flickity, new Promise(r => setTimeout(r, 1500))]);
          } catch (e) {}
        }
        if (window.innerWidth >= DESKTOP_BREAKPOINT && hasDesktopGallery) moveVideosToGrid();
        initVideoLazyLoading();
        initVideoPauseButtons();
        initVideoLooping();
        initImageZoom();
        initMobileLightbox();
        initAriaHiddenObserver();
        initLazyImageResizeHandler();
        initMobileFullWidthCarousel();
        initThumbnailFade();
        ensureRovingTabindex('.product__thumbnail-list', '.product__thumbnail-item');
        ensureRovingTabindex('.dots-nav', '.dots-nav__item');
      }
      document.addEventListener('pl:media-groups-updated', function() {
        // Let Focal's reload() replace the Flickity instance first.
        setTimeout(refreshAfterMediaChange, 0);
      });

      // Timing note: as a parse-time inline script this always saw
      // readyState === 'loading' and therefore ran on DOMContentLoaded - after
      // theme.js had booted Flickity. As a deferred asset it executes while
      // readyState is already 'interactive', so the old guard fell through to
      // the immediate else branch and ran BEFORE Flickity existed. The
      // flickityCarousel.flickity promise was then null, the wrapper revealed
      // at the uncorrected centerMode layout, and Flickity re-laid it out a
      // moment later - the visible double render. Wait for DOMContentLoaded
      // explicitly, with a load backstop so this can never hang.
      var __started = false;
      function __start() {
        if (__started) return;
        __started = true;
        init();
      }
      if (document.readyState === 'complete') {
        __start();
      } else {
        document.addEventListener('DOMContentLoaded', __start, { once: true });
        window.addEventListener('load', __start, { once: true });
      }
    })();